import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu } from 'lucide-react';

const TopNav: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Top navigation bar */}
      <nav className="fixed top-0 left-0 w-full bg-gradient-to-br from-[#1a1a1a] via-[#121212] to-[#0a0a0a] backdrop-blur-md shadow-lg z-50 px-6 py-2 flex items-center justify-between border-b border-cyan-800">
        {/* App title with logo */}
        <div className="flex items-center space-x-3">
          <img src="./logo.png" alt="Logo" className="h-6 w-6" /> {/* Logo */}
          <div className="text-2xl font-mono text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-pink-600 tracking-tight leading-tight">
            CRYPTO AI
          </div>
        </div>

        {/* Menu button */}
        <button
          onClick={() => setShowModal(true)}
          className="bg-gradient-to-r from-cyan-500 to-pink-600 px-4 py-2 rounded-md shadow-md hover:shadow-xl transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-cyan-600 focus:ring-opacity-50"
        >
          <Menu className="text-white" size={18} />
        </button>
      </nav>

      {/* Modal with animation */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 bg-black bg-opacity-90 backdrop-blur-lg flex items-center justify-center z-50"
            onClick={() => setShowModal(false)}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              onClick={(e) => e.stopPropagation()}
              className="bg-gradient-to-br from-[#2a2a2a] to-[#1a1a1a] p-8 w-full max-w-lg shadow-xl border border-cyan-700 relative"
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
            >
              {/* Terminal Header */}
              <div className="flex items-center space-x-2 mb-6">
                <div className="w-3 h-3 rounded-full bg-red-500 animate-pulse" />
                <div className="w-3 h-3 rounded-full bg-yellow-500 animate-pulse" />
                <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse" />
              </div>

              <h2 className="text-3xl font-mono text-green-400 mb-6 text-center">
                CRYPTO AI <span className="text-cyan-400">v1.0.1</span>
              </h2>

              {/* Terminal-like Text */}
              <p className="text-green-200 text-sm mb-6 leading-relaxed text-center">
                Maximize your crypto rewards with AI-driven mining, staking, and portfolio optimization across EVM and Solana chains.
              </p>

              {/* Links in terminal style */}
              <div className="text-sm text-gray-500 space-y-2">
                <p className="font-semibold text-gray-400">Support Links:</p>
                <a
                  href="https://youtube.com/@cryptopunch"
                  target="_blank"
                  rel="noreferrer"
                  className="block text-green-500 hover:text-cyan-400 transition-all duration-300"
                >
                  youtube.com/@cryptopunch
                </a>
                <a
                  href="mailto:ai-cryptotrading@zohomail.eu"
                  className="block text-green-500 hover:text-cyan-400 transition-all duration-300"
                >
                  ai-cryptotrading@zohomail.eu
                </a>
              </div>

              {/* Terminal activity */}
              <div className="mt-6">
                <div className="text-green-400 text-xs mb-2">ACTIVITY LOG</div>
                <div className="space-y-1 text-xs text-gray-400">
                  <p className="animate-pulse">Connecting to the network...</p>
                  <p className="animate-pulse">Retrieving crypto data...</p>
                  <p className="animate-pulse">AI mining algorithms active...</p>
                  <p className="animate-pulse">Optimizing portfolio...</p>
                  <p className="animate-pulse">Staking enabled on Solana...</p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default TopNav;
